/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_As_CsvInputs */

const en_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as CSV`)
};

const fr_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter en CSV`)
};

const de_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als CSV exportieren`)
};

const it_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta come CSV`)
};

const ru_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт в формате CSV`)
};

const es_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar como CSV`)
};

const zh_cn2_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出为 CSV 文件`)
};

const ja_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSVとしてエクスポート`)
};

const hi_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV फ़ाइल के रूप में निर्यात करें`)
};

const pt_pt2_export_as_csv = /** @type {(inputs: Export_As_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar como CSV`)
};

/**
* | output |
* | --- |
* | "Export as CSV" |
*
* @param {Export_As_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_as_csv = /** @type {((inputs?: Export_As_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_As_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_export_as_csv(inputs)
	if (locale === "de") return de_export_as_csv(inputs)
	if (locale === "it") return it_export_as_csv(inputs)
	if (locale === "ru") return ru_export_as_csv(inputs)
	if (locale === "es") return es_export_as_csv(inputs)
	if (locale === "zh-CN") return zh_cn2_export_as_csv(inputs)
	if (locale === "ja") return ja_export_as_csv(inputs)
	if (locale === "hi") return hi_export_as_csv(inputs)
	if (locale === "pt-PT") return pt_pt2_export_as_csv(inputs)
	return en_export_as_csv(inputs)
});